import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

export const TextRelated = ({ title, slug }) => (
  <Link to={`${slug}`}>
    <span>{title}</span>
  </Link>
);
const related = ({ title, slug, image }) => {
  const imageDimensions = {
    height: '113px',
    width: '75px',
  };
  return (
    <Link to={slug}>
      <GatsbyImage
        image={image}
        className="rounded shadow-md hover:shadow-xl"
        style={imageDimensions}
        alt={`Related book ${title} Cover`}
      />
    </Link>
  );
};

export default related;
